import padStart from "lodash/padStart";

export function formatTime(sec: number) {
  if (Number.isNaN(sec)) {
    return "";
  }
  const minutes = Math.floor(sec / 60);
  const seconds = Math.floor(sec - minutes * 60);
  return `${padStart(
    minutes.toString(),
    2,
    "0",
  )}:${padStart(seconds.toString(), 2, "0")}`;
}
